<template>
  <date-picker
    v-bind="$attrs"
    ref="picker"
    @drag="$emit('drag', $event)"
    @dayclick="$emit('dayclick', $event)"
    @input="$emit('input', $event)"
  >
    <div
      slot="header"
      slot-scope="page"
      class="header"
    >
      <button
        type="button"
        class="nav-left"
        :class="{ '-disabled': !page.canMove(page.prevMonthComps) }"
        @click.stop="page.move(-step)"
      >
        <c-icon size="16" icon="arrow-left" />

        <span class="tag">
          {{ months[page.prevMonthComps.month - 1] }}
        </span>
      </button>

      <span class="title">
        {{ page.title }}
      </span>

      <button
        type="button"
        class="nav-right"
        :class="{ '-disabled': !page.canMove(page.nextMonthComps) }"
        @click.stop="page.move(step)"
      >
        <span class="tag">
          {{ months[page.nextMonthComps.month - 1] }}
        </span>

        <c-icon size="16" icon="arrow-right" />
      </button>
    </div>
  </date-picker>
</template>

<script>
import 'v-calendar/src/styles/tailwind-lib.css'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import CIcon from '@convenia/components/CIcon'
import VCalendarCompatMixin from './VCalendarCompatMixin'

export default {
  name: 'VCalendarCompat',

  mixins: [ VCalendarCompatMixin ],

  components: {
    DatePicker,
    CIcon
  },

  computed: {
    step () {
      return Number(this.$attrs.columns || 1) * Number(this.$attrs.rows || 1)
    }
  },

  methods: {
    getController () {
      const [ controller ] = this.$refs.picker?.$children || []
      return controller || null
    },

    dateIsValid (value) {
      return this.$refs.picker?.dateIsValid?.(value) ?? true
    }
  }
}
</script>
